// extracted by mini-css-extract-plugin
export var slide = "style-module--slide--a802d";
export var slides = "style-module--slides--d963b";